import { createContext, useContext } from 'react';
import { FooterTypes } from '../footerTypes';

const variant: FooterTypes.TFooterVariantModes = 'footer-1';

export const VariantContext = createContext<FooterTypes.TFooterVariantModes>(
  variant
);
export const useVariant = () => useContext(VariantContext);
